// extracted by mini-css-extract-plugin
export var avatarContainer = "_1b-0";
export var avatarTypingWave = "_1b-i";
export var gray = "_1b-f";
export var green = "_1b-c";
export var icon = "_1b-9";
export var image = "_1b-1";
export var lg = "_1b-6";
export var md = "_1b-5";
export var presenceDot = "_1b-b";
export var red = "_1b-d";
export var sm = "_1b-4";
export var status = "_1b-a";
export var typingDot = "_1b-h";
export var typingPill = "_1b-g";
export var xl = "_1b-7";
export var xs = "_1b-3";
export var xxl = "_1b-8";
export var xxs = "_1b-2";
export var yellow = "_1b-e";